/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { removeSpecialCharacters } from '../../../../../../shared/string';
import t from '../../../../../../css/global.module.css';
import s from './suggestion.module.css';


const Category = ({ category, isLastCategory }) => (
  <span className={`${t.black} ${t.f6} ${s.category} ${isLastCategory && s.lastCategory}`}>
    {category.label}
  </span>
);

Category.propTypes = {
  category: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
    ]),
  ),
  isLastCategory: PropTypes.bool,
};

Category.defaultProps = {
  category: { label: '' },
  isLastCategory: false,
};

const Keyword = ({ query, keyword }) => {
  const cleanQuery = removeSpecialCharacters(query);
  let noBoldedKeyword = keyword;
  let boldedKeyword = null;
  if (keyword.startsWith(cleanQuery)) {
    noBoldedKeyword = keyword.substr(0, cleanQuery.length);
    boldedKeyword = keyword.substr(cleanQuery.length);
  }

  return (
    <span className={`${t.mr2}`}>
      { noBoldedKeyword }
      { boldedKeyword
        && <b>{boldedKeyword}</b>
      }
    </span>
  );
};

Keyword.propTypes = {
  query: PropTypes.string.isRequired,
  keyword: PropTypes.string.isRequired,
};

const Suggestion = (suggestion, { query }) => {
  const { keyword, category, isMobile } = suggestion;
  if (isMobile && category.label) {
    return (
      <div className={`${t['hover-bg-near-white']} ${t.pointer}`}>
        <Category {...suggestion} />
      </div>
    );
  }
  return (
    <div className={`${t['dark-gray']} ${t.f6} ${s.itemList} ${t['hover-bg-near-white']} ${t.pointer}`}>
      <Keyword query={query} keyword={keyword} />
      <Category {...suggestion} />
    </div>
  );
};

Suggestion.propTypes = {
  suggestion: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  ).isRequired,
};

export default Suggestion;
